import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { notify } from "../../helpers";
import { Loader } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { setOtpType } from "../../redux/actions";
import { UserDetails, sendOtp } from "../../services/login";
import Spacing from "../Spacing";

export default function OtpMethod() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [otpMethod, setOtpMethod] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailloading, setEmailLoading] = useState(false);
  const userDataDetails = useSelector((state) => state.user);
  const [userData, setUserData] = useState({
    phone: null,
    email: null
  });
  const now = new Date();
  const currentYear = now.getFullYear();

  const handleOtpMethodChange = async (otpMethod) => {
    try {
      await dispatch(setOtpType(otpMethod));
      if (otpMethod === "phone"){
        setLoading(true);
      } else{
        setEmailLoading(true);
      }
      await sendOtp({
        otp_type: otpMethod,
        username: userDataDetails.username,
        password: userDataDetails.password
      });
      navigate("/verify-otp");
    } catch (error) {
      notify("error", "Failed to set OTP method. Please try again.", 5);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      const data = await UserDetails({ user_name: userDataDetails.username });
      setUserData(data.data)
    }
    if (userDataDetails.username) {
      fetchUserDetails()
    }
    else {
      navigate("/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useDocumentTitle("Select OTP Method");

  return (
    <div className="docpro_login_wrap">
      <div
        className="docpro_login_thumb"
        style={{ backgroundImage: "url(/images/login_img.png)" }}
      ></div>
      <div className="docpro_login_right">
        <div className="docpro_login_card_wrap">
          <div className="docpro_login_card">
            <div className="docpro_text_center">
              <img src="/images/logo_2.svg" alt="Logo" />
              <Spacing lg="32" sm="32" />
              <h1 className="docpro_mb_0">Select OTP Delivery Method</h1>
            </div>
            <Spacing lg="20" sm="20" />
            <form>
              <label className="docpro_fw_500 docpro_primary_color">
                Select OTP Delivery Method
              </label>
              <Spacing lg="20" sm="20" />

              {userData &&
                <>
                  <div className="flex otp_btn_div">
                    <button
                      type="button"
                      onClick={() => handleOtpMethodChange("phone")}
                      className={`docpro_bordered_btn mb-2 docpro_fw_600 docpro_filed_btn size_lg`}
                    >
                      Sent One Time Password to {`XXX-XXX-${userData?.phone?.slice(-4)}`}
                      {loading && (
                        <span className="docpro_loading">
                          <Loader width={20} height={20} />
                        </span>
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => handleOtpMethodChange("email")}
                      className={`docpro_bordered_btn docpro_fw_600 font_14 docpro_filed_btn size_lg`}
                    >
                      Send One Time Password to {`XXXXXXX${userData?.email?.split('@')[0].slice(-3)}@${userData?.email?.split('@')[1]}`}
                      {emailloading && (
                        <span className="docpro_loading">
                          <Loader width={20} height={20} />
                        </span>
                      )}
                    </button>
                  </div>
                </>
              }
            </form>
            <Spacing lg="16" sm="16" />
          </div>
        </div>
        <footer className="docpro_login_footer">
          <div className="docpro_login_footer_nav">
            <Link to="/">Privacy policy</Link>
            <Link to="/">Terms & conditions</Link>
            <Link to="/">Terms of service</Link>
            <Link to="/">HIPAA Compliance</Link>
          </div>
          <p>© {currentYear} DocPro. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
